<template>
  <ButtonCategoryBase
    v-if="available"
    :category="category"
    :parent-display-type="parentDisplayType"
    :to="routeLink.path"
    :disabled="disabled"
    :m-medias="mPageMedias"
    @click.capture="handleClick"
  />
</template>
<script lang="ts" setup>
import {
  getCategoryRouterAction,
  getIsDeepLink,
} from '~/lib/category/actionHelper';

import { categoryDeepLinkParser } from '~/lib/category/deepLinkParser';

interface Props {
  category: CategorySchema;
  parentDisplayType?:
    | 'default'
    | 'center_circle'
    | 'dimensionTest_and_result'
    | 'sponsor'
    | 'shortcuts'
    | 'additional';
}

const props = defineProps({
  category: null,
  parentDisplayType: { default: 'default' }
});

const { $db } = useNuxtApp();

const { currentContent, mPageMedias, categoryLockState } =
  inject(INJECT_CATEGORY_PAGE);

const available = defineModel<boolean>('available', {
  default: true,
});

const disabled = computed(() => {
  return isDeepLink && !routeLink.path;
});

const route = useRoute();

const { all: allUserContents } = useContentsForUserType();

const dialogLockedContent = useDialogLockedContent();

let linkedContent: CategorySchema | PostSchema | ExerciseSchema;

const isDeepLink = getIsDeepLink(props.category);

const contents = useContents();

let routeLink;

let isLocked: boolean = false;

if (isDeepLink) {
  routeLink = await categoryDeepLinkParser(
    $db,
    deepToRaw(props.category),
    contents.all.value,
    contents.mainContent.value,
    route.path === '/'
  );
  if (routeLink.path && routeLink.path.indexOf('/nomad/') === 0) {
    const slug = routeLink.path.split('/nomad/')[1];
    const lbInstalled = allUserContents.value.find(
      (content) => content.slug === slug
    );

    if (lbInstalled) {
      routeLink = { ...routeLink, path: lbInstalled.path };
    }
  }
} else {
  const routerAction = await getCategoryRouterAction(
    $db,
    props.category,
    currentContent.value,
    categoryLockState.value.getIsTypeLocked,
    route.path
  );

  linkedContent = routerAction.linkedContent;
  routeLink = routerAction.routeLink;
  isLocked = routerAction.isLocked;
}

const handleClick = (e) => {
  if (isDeepLink && routeLink.path) {
    useAppEventView(EventView.Deeplink, props.category.id, {
      url: routeLink.path,
    });
  }
  if (isLocked) {
    e.preventDefault();
    dialogLockedContent.open(
      linkedContent.contentType,
      null,
      null,
      useAppEventShare(
        EventAssociatedModel.ContentLockScreen,
        props.category.id,
        linkedContent.contentType || linkedContent.lockedContent
      )
    );
  }
};

available.value = isDeepLink ? routeLink.path != null : true;
</script>
<style lang="scss" scoped></style>
